import { createMongoAbility } from "@casl/ability";
// import secureLocalStorage  from  "react-secure-storage";

// Read ability from secureLocalStorage
const abilityJSON = localStorage.getItem("ability");
const existingAbility = abilityJSON ? JSON.parse(abilityJSON) : [];

// Create the final ability instance
const mergedAbility = createMongoAbility(existingAbility);

export default mergedAbility;
